import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const AnalyticsCurrencyBarChart = ({ data, emptyMessage }) => {
  const hasData = data?.some((d) => d.amount > 0);

  if (!hasData) {
    return (
      <div className="aa-chart-card">
        <div className="aa-chart-card__head">
          <h3>Revenue by currency</h3>
          <p>Total booking value per currency</p>
        </div>
        <div className="aa-chart-card__empty">{emptyMessage || "No data"}</div>
      </div>
    );
  }

  return (
    <div className="aa-chart-card">
      <div className="aa-chart-card__head">
        <h3>Revenue by currency</h3>
        <p>Total booking value per currency</p>
      </div>
      <div className="aa-chart-card__bar-wrap aa-chart-card__bar-wrap--vertical">
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={data} margin={{ top: 12, right: 12, left: 0, bottom: 8 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e7e5e4" vertical={false} />
            <XAxis
              dataKey="currency"
              tick={{ fontSize: 12, fill: "#78716c" }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              tick={{ fontSize: 11, fill: "#78716c" }}
              axisLine={false}
              tickLine={false}
              width={56}
            />
            <Tooltip
              cursor={{ fill: "rgba(254, 127, 41, 0.08)" }}
              formatter={(value) => [value, "Amount"]}
              contentStyle={{
                borderRadius: 10,
                border: "1px solid #e7e5e4",
                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              }}
            />
            <Bar
              dataKey="amount"
              fill="url(#currencyBarGradient)"
              radius={[8, 8, 0, 0]}
              maxBarSize={56}
            />
            <defs>
              <linearGradient id="currencyBarGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#fb923c" />
                <stop offset="100%" stopColor="#ea580c" />
              </linearGradient>
            </defs>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AnalyticsCurrencyBarChart;
